<template>
    <div class="content">
        <div class="assios_conent">
            <div class="bg_color"></div>
            <!--用户信息-->
            <div class="userinfo-wrap">
                <div class="user-left">
                    <div class="head-img">
                        <img :src="objUserBordInfo.avatar" alt="">
                    </div>
                    <div class="hed-info">
                        <div class="name">{{objUserBordInfo.name}}<span>{{objUserBordInfo.org_name}}</span></div>
                        <div class="company">{{objUserBordInfo.business_name}}</div>
                    </div>
                </div>
                <div class="red-right" @click="toBell">
                    <img src="@/assets/images/hvac/dossier/Frame2x.png" />
                </div>
            </div>
            <div class="plane-title" @click="toPlane">
                <img src="@/assets/images/hvac/dossier/icon-tit.png" />
                <span>用户交付/口碑看板</span>
            </div>
            <div class="info-box" @click="toPlane">
                <div class="info-item">
                    <div class="value">{{objBordInfo.shared_num}}</div>
                    <div class="name">已交付(次)</div>
                </div>
                <div class="info-item">
                    <div class="value">{{objBordInfo.valid_num}}</div>
                    <div class="name">有效交付(次)</div>
                </div>
                <div class="info-item">
                    <div class="value">{{objBordInfo.discuss_num}}</div>
                    <div class="name">已评价</div>
                </div>
                <div class="info-item">
                    <div class="value">{{objBordInfo.money}}</div>
                    <div class="name">我的奖励(元)</div>
                </div>
            </div>
            <div class="nav_content">
                <div :class="['nav',item.type_value == type_value?'atv_nav':'']" v-for="(item,index) in topTag" :key="index" @click="changeItem(item)">
                    {{ item.type_name }}
                </div>
            </div>
            <div class="content_wrap">
                <!--                @scroll.passive="getSorll($event)"-->
                <div class="app_content">
                    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getSorll">
                        <div class="seach_warp">
                            <div class="seach_item_top">
                                <div class="left" @click="dataview.lock_region == 1?null:bPickShow = true">
                                    <span>{{ regionName ? regionName : '大区' }}</span>
                                </div>
                                <div class="right" @click.stop="onTimeItemShow">
                                    <template v-if="dateTime[0] != '' || dateTime[1] != ''">
                                        <div class="right-start">{{ dateTime[0] }}</div>
                                        ~
                                        <div class="right-end">{{ dateTime[1] }}</div>
                                    </template>
                                    <template v-else>
                                        <div class="right_item">请选择时间区间</div>
                                    </template>
                                </div>
                            </div>
                            <div class="seach_item_bottom">
                                <div class="left" @click="dataview.lock_district == 1?null:bDistrict = true">
                                    <span>{{ proityValue ? proityValue : '省市' }}</span>
                                </div>
                                <div class="right">
                                    <div class="right_item" @click="dataview.lock_business == 1?null:bBusiness = true">
                                        {{ businessName ? businessName : '请选择代理商' }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 看板数据 -->
                        <div class="bulletin_content" v-if="arrBoard.length">
                            <div class="bulletin_title bulletin_icon">看板数据</div>
                            <div class="bulletin_warp">
                                <div class="bulletin_warp_item" v-for="(item,index) in arrBoard" :key="index">
                                    <div>{{ item.dis_name }}</div>
                                    <div class="num">{{ item.num }}</div>
                                </div>
                            </div>
                        </div>
                        <!-- 用户分布 -->
                        <div class="bulletin_content" v-if="false">
                            <div class="bulletin_title distribution_icon">用户分布</div>
                            <div class="distribution_nav">
                                <div :class="[nDisIndex == index?'atv_nav':'']" v-for="(item,index) in arrMapdata" :key="index" @click="getDisIndex(index)">
                                    {{ item.dis_name }}
                                </div>
                            </div>
                            <div class="user_map">
                                <div id="china_map"></div>
                            </div>
                            <!-- 省市划分 -->
                            <div class="distribution_nav">
                                <div :class="[nCityIndex == item.id?'atv_nav':'']" v-for="(item,index) in arrCity" :key="item.id" @click="clickCity(item.id)">
                                    {{ item.name }}
                                </div>
                            </div>
                        </div>
                        <!-- 用户日志 -->
                        <div class="bulletin_content">
                            <div class="bulletin_title journal_icon">用户日志</div>
                            <div class="seach_warp">
                                <div class="seach_input">
                                    <input v-model="seachKeyWord" placeholder="搜索客户" @blur="blurSeach" />
                                </div>
                                <div class="screen" @click="searchClick">
                                    <img src="@/assets/images/hvac/dossier/screen_icon.png" />
                                </div>
                            </div>
                            <van-notice-bar v-if="sTipsText != ''" background="#E7EEFF" color="#3D3C4F" left-icon="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/tips.png" :text="sTipsText" />
                            <div class="seach_list" v-if="arrUserLog.length">
                                <div class="seach_item" v-for="(item,index) in arrUserLog" :key="index">
                                    <div class="seach_dateTime">{{ item.tab_date }}</div>
                                    <div class="seach_item_warp" v-for="(sumitem,sumindex) in item.arrElement" :key="sumindex" @click="$router.push({path:'/archives/dossier',query:{account_id:sumitem.account_id,contract_id:sumitem.new_contractid}})">
                                        <div :class="['green',sumitem.status_icon + '1']"></div>
                                        <div class="item_warp_content">
                                            <div class="uninfo">
                                                <div :class="['item_green',sumitem.status_icon]">{{
                                                        sumitem.new_status
                                                    }}
                                                </div>
                                                <div class="uninfo_name">
                                                    <div class="name">{{ sumitem.name }}</div>
                                                    <div class="phone">{{ sumitem.phone }}</div>
                                                    <div class="manandday" v-if="sumitem.workday">{{
                                                            sumitem.workday.complete == 0 ? '已施工' : '共施工'
                                                        }}{{ sumitem.workday.total }}天
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="uninfo_warp" v-if="sumitem.tab_1.length">
                                                <div class="uninfo_item" v-for="(subitem,subindex) in sumitem.tab_1" :key="subindex">
                                                    <div class="uninfo_item_left">{{ subitem.field_name }}</div>
                                                    <!--                                                :style="{display:sumitem.bTips?'block':'flex'}"-->
                                                    <div :class="['uninfo_item_right',subitem.field_name == '驳回原因'?'ellipsis':'']" v-html="subitem.field_value"></div>
                                                </div>
                                                <!-- <div class="uninfo_item">
                                                <div class="uninfo_item_left">详细地址：</div>
                                                <div class="uninfo_item_right">上海奉贤区万达小区50栋5005室1111asda啊实打实打算</div>
                                            </div>
                                            <div class="uninfo_item">
                                                <div class="uninfo_item_left">丢单原因：</div>
                                                <div class="uninfo_item_right">客户选择竞品</div>
                                            </div>
                                            <div class="uninfo_item">
                                                <div class="uninfo_item_left">签单手：</div>
                                                <div class="uninfo_item_right dian">
                                                    马生生
                                                    <div>···</div>
                                                </div>
                                            </div> -->
                                            </div>
                                            <div class="uninfo_warp borderTop" v-if="sumitem.tab_2.length">
                                                <div class="uninfo_item" v-for="(subitem,subindex) in sumitem.tab_2" :key="subindex">
                                                    <div class="uninfo_item_left">{{ subitem.field_name }}</div>
                                                    <div :class="['uninfo_item_right',subitem.field_name == '驳回原因'?'ellipsis':'']" v-html="subitem.field_value"></div>
                                                </div>
                                            </div>
                                            <div class="problem" v-if="sumitem.msg != ''">{{ sumitem.msg }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!arrUserLog.length" class="listError">暂无数据...</div>
                        </div>
                    </van-list>
                </div>
            </div>
            <div v-if="bPower" class="power" @click.stop></div>
        </div>
        <div class="bottom_tab">
            <template v-for="(item,index) in arrBottomTab">
                <div class="bottom_item" @click.stop="checkTab(index)">
                    <img :src="nBottomIndex === index?item.imgUrl:item.unImgeUrl" />
                    <div :class="{'act':nBottomIndex === index}">{{ item.showName }}</div>
                </div>
            </template>
        </div>
        <!-- 时间选择器 -->
        <!--  <van-calendar v-model="show" type="range" :default-date="[new Date(startTime),new Date(endTime)]"
                              color="#0D53FC" :min-date="minDate" :max-date="maxDate" @confirm="onConfirm"/>-->
        <!--<van-popup v-model="show" round position="bottom">-->
        <!--    <van-datetime-picker-->
        <!--        type="date"-->
        <!--        v-model="dateValue"-->
        <!--        :title="dateTitle"-->
        <!--        :min-date="minDate"-->
        <!--        :max-date="maxDate"-->
        <!--        @cancel="onDateCancel"-->
        <!--        @confirm="onDateConfirm"-->
        <!--    />-->
        <!--</van-popup>-->
        <!-- 时间筛选项选择器 -->
        <van-popup v-model="timeItemShow" round position="bottom">
            <div class="time-item-wrap">
                <div class="time-item-title">
                    <div></div>
                    <div>周期</div>
                </div>
                <div class="time-item-content">
                    <div v-for="(item, index) in timeSelectList" :key="index" :class="['time-item-content-item', timeSelect == index && 'time-item-content-item-act']" @click="changeSelectTime(index)">
                        {{ item }}
                    </div>
                </div>
                <div class="time-input-wrap">
                    <div :class="['time-input-item', timeSelectItem == 'start' && 'time-input-item-act']" @click.stop="onDateShow('start', 'btn')">{{ dateTime[0] }}
                    </div>
                    至
                    <div :class="['time-input-item', timeSelectItem == 'end' && 'time-input-item-act']" @click.stop="onDateShow('end', 'btn')">{{ dateTime[1] }}
                    </div>
                </div>
            </div>

            <div class="search-btn" @click="checkData">
                <div class="btn">查询</div>
            </div>

            <transition name="fade">
                <div class="timepicker-wrap" v-if="show">
                    <van-datetime-picker type="date" v-model="dateValue" :title="dateTitle" :confirm-button-text="confirmButtonText" :min-date="minDate" :max-date="maxDate" @cancel="onDateCancel" @confirm="onDateConfirm" />
                </div>
            </transition>
        </van-popup>
        <!-- 大区选择器 -->
        <van-popup round v-model="bPickShow" position="bottom">
            <van-picker show-toolbar value-key="region_name" @confirm="reConfirm" @cancel="reCancel" :columns="region" />
        </van-popup>
        <!-- 地区选择器 -->
        <van-popup round v-model="bDistrict" position="bottom">
            <van-cascader title="请选择所在地区" :options="district" :field-names="fieldNames" @finish="onFinish" @close="close" />
        </van-popup>
        <!-- 代理商选择器 -->
        <van-popup round v-model="bBusiness" position="bottom">
            <van-search show-action placeholder="请输入代理商名称" @clear="clearKeywork" v-model="sProviderSearch">
                <template #action>
                    <div @click="getBusinessData">搜索</div>
                </template>
            </van-search>
            <van-picker show-toolbar value-key="name" @confirm="busConfirm" @cancel="busCancel" :columns="business" />
        </van-popup>
        <dossier ref="dossier" :typeValue="type_value" @chilkFrom="chilkFrom"></dossier>
    </div>
</template>

<script>
/**
 * wzh
 * 用户宗卷
 * */
import oWarmJs from "@/js/hvac/dossier/warm.js"
import { getUser } from "@/js/user/user.js"
import dossier from '@/components/hvac/dossier'
import { provinceGeo, cityGeo } from "@/js/hvac/performance/jsonGeo.js"
import result from "../../../js/hvac/performance/result";

export default {
    name: 'HvacWarm_useKP',
    components: {
        dossier
    },
    data() {
        return {
            objUserBordInfo: {
                name: '',
                org_name: '',
                business_name: '',
                avatar: ''
            },
            objBordInfo: {},
            loading: true,
            finished: false,
            topTag: [],
            arrCity: [{
                name: "全国",
                id: 1,
            }, {
                name: "省",
                id: 2,
            }],
            nBottomIndex: 1,
            arrBottomTab: [
                {
                    imgUrl: require('@/assets/images/hvac/dossier/tools.png'),
                    unImgeUrl: require('@/assets/images/hvac/dossier/untools.png'),
                    showName: "工具箱"
                },
                {
                    imgUrl: require('@/assets/images/hvac/dossier/uservolume.png'),
                    unImgeUrl: require('@/assets/images/hvac/dossier/unuservolume.png'),
                    showName: "用户卷宗"
                },
            ],
            sProviderSearch: "",//代理商搜索
            nCityIndex: 1,
            nPage: 0,
            seachKeyWord: "",
            dateTime: ['', ''],
            show: true,
            dateTitle: '请选择开始时间',
            confirmButtonText: '确定',
            dateInfo: {
                start: '',
                end: '',
            },
            dateKey: 'start',
            dateValue: null,//用了绑定日期选择的值
            minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 3)),
            maxDate: new Date(),
            startTime: '',
            endTime: '',
            //大区
            region: [{
                region_name: ""
            }],
            bPickShow: false,
            regionId: 'all',
            regionName: "",
            //地区
            fieldNames: {
                text: 'name',
                value: 'code',
                children: 'children',
            },
            district: [],
            proityValue: '', //省市区
            provinceCode: 'all', //省code
            cityCode: 'all', //市code
            cityName: '',
            bDistrict: false,
            districtId: 0,
            //代理商
            business: [],
            bBusiness: false,
            businessId: 'all',
            businessName: "",
            arrBoard: [], //看板数据
            arrMapdata: [], //用户分布
            sTipsText: '', //通知
            nDisIndex: 0,
            arrSelected: [],
            arrUserLog: [{
                tab_date: '',
                arrElement: [],
            }], //用户日志
            mapChart: null,
            type_value: 2,
            mapType: 'china',
            arrMap: [],
            clickMapType: 'province',
            maxNum: 0,//全国省市 最大数量
            dataview: {},// 用户权限
            bEmptyLoad: false,
            bPower: false,
            timeSelectList: ['总计', '年累计', '月累计', '周累计', '昨天'], // 时间筛选项数组
            timeItemAllArr: [], // 时间筛选项对应的时间数组
            timeItemShow: false, // 时间筛选项选择器
            timeSelect: '1', // 时间筛选项
            timeSelectItem: '1', // 详细时间筛选项选择器
        };
    },
    created() {
        this.getDateData()
        this.axiosObj();
        this.getTimeItem()
        this.getBordInfo()
        this.getBordUserInfo()
    },
    methods: {
        getBordUserInfo() {
            oWarmJs.bordUserInfo().then(res => {
                this.objUserBordInfo = res.data.data.result
            }).catch(err => {
                console.log(err, '用户1')
            })
        },
        getBordInfo() {
            oWarmJs.bordInfo().then(res => {
                this.objBordInfo = res.data.data.result
            })
        },
        // 跳转铃铛
        toBell() {
            this.$router.push({
                path: `/archives/user/record`,
                query: {}
            })
        },
        // 跳转铃铛
        toPlane() {
            this.$router.push({
                path: `/archives/user/report`,
                query: {}
            })
        },
        checkTab(index) {
            if (index == 0) {
                window.location.href = process.env.VUE_APP_TOOL
            }
        },
        getDataviewInfo() {
            return new Promise((resolve, recject) => {
                oWarmJs.getDataviewInfo().then(res => {
                    resolve(res.data.data.result)
                }).catch(err => {
                    this.bPower = true;
                    recject(err)
                })
            })
        },
        clearKeywork() {
            this.sProviderSearch = '';
        },
        axiosObj() {
            this.$store.commit("loadSwitch", true);
            this.getDataviewInfo().then(res => {
                //is_auth == 1  表示有权限
                this.dataview = res;
                if (res.is_auth == 1) {
                    Promise.all([res.lock_region == 1 ? res.region : this.getRegionData(), res.lock_district == 1 ? res.district : this.getDistrictData(), res.lock_business == 1 ? res.business : this.getBusinessData(), this.getWarmData()]).then(data => {
                        if (res.lock_region == 1) {
                            if (res.region.constructor == Object) {
                                this.regionName = res.region.region_name;
                                this.regionId = res.region.region_value;
                            } else {
                                this.regionId = '';
                            }
                        }
                        if (res.lock_district == 1) {
                            if (res.district.constructor == Object) {
                                this.provinceCode = '';
                                this.cityCode = '';
                                this.proityValue = '';
                            } else {
                                this.provinceCode = '';
                                this.cityCode = '';
                            }
                        }
                        if (res.lock_business == 1) {
                            if (res.business.constructor == Object) {
                                this.businessName = res.business.name;
                                this.businessId = res.business.uuid;
                            } else {
                                this.regionName = '';
                                this.regionId = '';
                            }
                        }
                        this.getBoardData();
                    })
                } else {
                    this.$toast('无权限')
                    this.bPower = true;
                    this.$store.commit("loadSwitch", false);
                }
            })
            // Promise.all([this.getRegionData(), this.getDistrictData(), this.getBusinessData(), this.getDateData(),this.getWarmData()]).then(data => {
            //     this.getBoardData();
            // })
        },
        changeItem(item) {
            this.type_value = item.type_value;
            this.bEmptyLoad = false;
            this.nPage = 0;
            this.arrUserLog = [];
            this.axiosObj();
            this.$refs.dossier.getSearUserData(item.type_value);
        },
        //获取数据
        getWarmData() {
            oWarmJs.getSearchToptag().then(res => {
                this.topTag = res.data.data.result
            })
        },
        close() {
            this.bDistrict = false;
        },
        onFinish(e) {
            if (e.tabIndex == 0) {
                this.proityValue = e.selectedOptions[e.tabIndex].name;
                this.provinceCode = e.selectedOptions[e.tabIndex].code;
                this.cityCode = e.selectedOptions[e.tabIndex].code;
                this.cityName = e.selectedOptions[e.tabIndex].name;
            } else {
                this.proityValue = e.selectedOptions[e.tabIndex - 1].name + '-' + e.selectedOptions[e.tabIndex].name;
                this.provinceCode = e.selectedOptions[e.tabIndex - 1].code;
                this.cityCode = e.selectedOptions[e.tabIndex].code;
                this.cityName = e.selectedOptions[e.tabIndex].name;
            }

            // 清空代理商
            this.businessId = '';
            this.businessName = '';
            Promise.all([this.getBusinessData()]).then(() => {
                this.getBoardData()
                this.bDistrict = false;
            })
        },
        // 筛选框
        searchClick() {
            this.$refs.dossier.isShowSearch = true
        },
        getDisIndex(nIndex) {
            this.nDisIndex = nIndex;
            let arrMap = [];
            this.arrMapdata[this.nDisIndex].map.forEach(it => {
                arrMap.push({
                    name: it.name,
                    value: it.num
                })
            })
            this.arrMap = arrMap;
            this.mapType = 'china';
            this.drawregionCharts();
        },
        //获取时间范围
        getDateData() {
            return new Promise((resolve, recject) => {
                oWarmJs.getSearchDefaultDate().then(res => {
                    // this.startTime = (res.data.data.result.start).replace(/\-/g, '/');
                    // this.endTime = (res.data.data.result.end).replace(/\-/g, '/');

                    let date = new Date()
                    // 当前时间没过今年12/27的话，账期开始时间就用上一年的12/28 账期结束时间就用今天
                    // 过了的话就用今年的12/28 账期结束时间用今天
                    let currentYear = date.getFullYear()
                    let currentMonth = date.getMonth() + 1
                    let currentDate = date.getDate()
                    let tempTime = currentYear + '/12/27 23:59:59'
                    let checkStartTime = ''
                    let checkEndTime = currentYear + '/' + currentMonth + '/' + currentDate
                    if (new Date().getTime() < new Date(tempTime).getTime()) {
                        checkStartTime = currentYear - 1 + '/12/28'
                    } else {
                        checkStartTime = currentYear + '/12/28'
                    }
                    this.startTime = checkStartTime
                    this.endTime = checkEndTime
                    // console.log(checkStartTime);
                    // console.log(checkEndTime);
                    this.maxDate = new Date(this.endTime);
                    // this.minDate = new Date(this.startTime);
                    this.minDate = new Date('2000/01/01');
                    this.dateValue = new Date(this.startTime);
                    // this.dateTime = `${this.startTime}~${this.endTime}`;
                    this.dateTime = [this.startTime, this.endTime];
                    resolve()
                })
            })
        },
        formatDate(date) {
            let month = date.getMonth() + 1;
            let day = date.getDate();
            return `${date.getFullYear()}/${month > 9 ? month : '0' + month}/${day > 9 ? day : '0' + day}`;
        },
        // 时间选择项点击
        onTimeItemShow() {
            this.timeItemShow = true
            this.onDateShow('start')
        },
        // 获取时间项的具体时间
        getTimeItem() {
            let date = new Date();
            // 当年
            const toYear = date.getFullYear() + '/01/01';
            // 当月
            const toMonth = date.getFullYear() + '/' + ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1))
            // 当天
            const today = (date.getFullYear() + '/' + ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)) + '/' + (date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()));
            // 昨天
            let yesterdayDate = new Date(today);
            yesterdayDate.setDate(yesterdayDate.getDate() - 1);
            const yesterday = yesterdayDate.getFullYear() + '/' + ((yesterdayDate.getMonth() + 1) < 10 ? '0' + (yesterdayDate.getMonth() + 1) : (yesterdayDate.getMonth() + 1)) + '/' + (yesterdayDate.getDate() < 10 ? ('0' + yesterdayDate.getDate()) : yesterdayDate.getDate());
            // 本周一
            let mondayDate = new Date(date);
            mondayDate.setDate(date.getDate() - date.getDay() + 1);
            const monday = mondayDate.getFullYear() + '/' + ((mondayDate.getMonth() + 1) < 10 ? '0' + (mondayDate.getMonth() + 1) : (mondayDate.getMonth() + 1)) + '/' + (mondayDate.getDate() < 10 ? ('0' + mondayDate.getDate()) : mondayDate.getDate());

            // 计算账期开始日期
            let currentYear = date.getFullYear()
            let currentMonth = date.getMonth() + 1
            let currentDate = date.getDate()
            let tempTime = currentYear + '/12/27 23:59:59'
            let checkStartTime = ''
            // let checkEndTime = currentYear + '/' + currentMonth + '/' + currentDate
            if (new Date().getTime() < new Date(tempTime).getTime()) {
                checkStartTime = currentYear - 1 + '/12/28'
            } else {
                checkStartTime = currentYear + '/12/28'
            }
            this.timeItemAllArr = [['2021/01/01', today], [checkStartTime, today], [toMonth + '/01', today], [monday, today], [yesterday, yesterday]]
        },
        // 点击时间项改变时间
        changeSelectTime(index) {
            if (index == this.timeSelect) return
            this.timeSelect = index
            this.timeSelectItem = ''

            switch (index) {
                case 0: // 总计 2021-01-01到当天
                    this.dateTime = this.timeItemAllArr[0];
                    break;
                case 1: // 当年 当年1.1至当天
                    this.dateTime = this.timeItemAllArr[1];
                    break;
                case 2: // 月累计 当月1号至当天
                    this.dateTime = this.timeItemAllArr[2];
                    break;
                case 3: // 周累计 当周周一至当天
                    this.dateTime = this.timeItemAllArr[3];
                    break;
                case 4: // 昨日
                    this.dateTime = this.timeItemAllArr[4];
                    break;
            }

            // 点击时间项后下方的日期选择变为周期的开始时间
            this.onDateShow('start')

            // 点击确定后再进行请求数据
            // this.bEmptyLoad = false;
            // this.nPage = 0;
            // this.arrUserLog = [];
            // this.getBoardData()
            //
            // this.timeItemShow = false
            // this.show = false
        },
        // 判断所选时间是否满足所选项
        judgeTimeItem(arr) {
            let index = -1
            let flag = true;
            for (let i = 0; i < this.timeItemAllArr.length; i++) {
                index = i;
                for (let j = 0; j < this.timeItemAllArr[i].length; j++) {
                    if (this.timeItemAllArr[i][j] != arr[j]) {
                        flag = false
                        break;
                    }
                }
                if (flag) {
                    break;
                } else {
                    if (index == this.timeItemAllArr.length - 1) {
                        index = -1
                    }
                    flag = true
                }
            }
            return index
        },
        onDateShow(key, type) {
            this.dateKey = key;
            this.timeSelectItem = key
            this.show = false
            setTimeout(() => {
                if (key == 'start') {
                    this.dateTitle = '请选择开始时间';
                    this.confirmButtonText = '确定'
                    this.dateValue = new Date(this.dateTime[0]);
                    // this.minDate = new Date(this.dateTime[0]);
                    if (this.dateTime[1] != '') {
                        this.maxDate = new Date(this.dateTime[1]);
                    }
                } else {
                    this.dateTitle = '请选择结束时间';
                    // this.confirmButtonText = '查询'
                    console.log(this.endTime, 'this.endTime');
                    this.dateValue = new Date(this.dateTime[1])
                    this.maxDate = new Date(this.endTime);
                    if (this.dateTime[0] != '') {
                        // this.minDate = new Date(this.dateTime[0]);
                    }
                }

                if (type == 'btn') {
                    // this.minDate = new Date('2021/01/01');
                    this.maxDate = new Date();
                }
                this.show = true;
            }, 100)
            this.show = false;
        },
        onDateCancel() {
            // this.show = false;
            this.dateTitle = '请点击查询按钮筛选'
            this.dateInfo = {
                start: '',
                end: '',
            }
        },
        onDateConfirm(e) {
            if (this.dateKey == 'start') {
                this.dateInfo.start = e;
                this.dateInfo.end = new Date(this.dateTime[1]);
                this.onConfirm(this.dateInfo, 'start')
                this.onDateCancel();
            } else {
                this.dateInfo.start = new Date(this.dateTime[0]);
                this.dateInfo.end = e;
                this.onConfirm(this.dateInfo, 'end')
                this.onDateCancel();
                // this.timeItemShow = false
            }
        },
        onConfirm(date, type) {
            // const [start, end] = date;
            const { start, end } = date;
            // this.dateTime = `${this.formatDate(start)} - ${this.formatDate(end)}`;
            this.dateTime = [this.formatDate(start), this.formatDate(end)];
            console.log(this.dateTime, 'this.dateTime')
            // this.startTime = this.formatDate(start);
            // this.endTime = this.formatDate(end);

            // 判断手动修改的时间是否满足筛选项高亮
            this.timeSelect = this.judgeTimeItem(this.dateTime)
            if (type == 'start') {
                // 切到结束时间去
                this.onDateShow('end')
                return
            }
            // this.show = false;

            // this.bEmptyLoad = false;
            // this.nPage = 0;
            // this.arrUserLog = [];
            // this.getBoardData()
        },
        // 点击查询
        checkData() {
            this.timeItemShow = false
            this.bEmptyLoad = false;
            this.nPage = 0;
            this.arrUserLog = [];
            this.getBoardData()
        },
        //获取大区数据
        getRegionData() {
            return new Promise((resolve, recject) => {
                oWarmJs.getSearchRegion().then(res => {
                    this.region = res.data.data.result
                    resolve(res.data.data.result)
                })
            })
        },
        //大区选择器确定按钮
        reConfirm(value, index) {
            this.bPickShow = false;
            this.regionName = value.region_name;
            this.regionId = value.region_value;
            this.bEmptyLoad = false;
            this.nPage = 0;
            this.arrUserLog = [];
            // 清空省市
            this.provinceCode = '';
            this.cityCode = '';
            this.proityValue = '';
            // 清空代理商
            this.businessId = '';
            this.businessName = '';
            Promise.all([this.getBusinessData(), this.getDistrictData()]).then(() => {
                this.getBoardData()
            })
        },
        //大区选择器取消按钮
        reCancel(value, index) {
            this.bPickShow = false;
        },
        //获取省市数据
        getDistrictData() {
            return new Promise((resolve, recject) => {
                oWarmJs.getSearchDistrict({ region_value: this.regionId ? this.regionId : 'all' }).then(res => {
                    let arr = [];
                    // let arrCode = res.data.data.result.filter(it=>{
                    //     return it.code == this.provinceCode;
                    // })
                    // if(!arrCode.length){
                    //     this.provinceCode = '';
                    //     this.cityCode = '';
                    //     this.proityValue = '';
                    // }
                    res.data.data.result.forEach(it => {
                        let children = [];
                        it.sublist.forEach(is => {
                            children.push({
                                name: is.name,
                                code: is.code
                            })
                        })
                        if (children.length) {
                            arr.push({
                                name: it.name,
                                code: it.code,
                                children: children
                            })
                        } else {
                            arr.push({
                                name: it.name,
                                code: it.code
                            })
                        }
                    })
                    this.district = arr;
                    resolve(arr)
                })
            })
        },
        //代理商数据
        getBusinessData() {
            return new Promise((resolve, recject) => {
                oWarmJs.getSearchBusiness({
                    region_value: this.regionId ? this.regionId : 'all',
                    keyword: this.sProviderSearch,
                    city_name: this.cityName
                }).then(res => {
                    this.business = res.data.data.result;
                    if (res.data.data.result.length == 2) {
                        let arr = this.business.filter(it => it.uuid != 'all');
                        if (arr.length == 1) {
                            this.businessId = arr[0].uuid;
                            this.businessName = arr[0].name;
                        }
                    }
                    resolve(res.data.data.result)
                })
            })
        },
        //代理商确认按钮
        busConfirm(value, index) {
            this.bBusiness = false;
            this.businessId = value.uuid;
            this.businessName = value.name;
            this.bEmptyLoad = false;
            this.nPage = 0;
            this.arrUserLog = [];
            this.getBoardData()
        },
        //代理商取消按钮
        busCancel(value, index) {
            this.bBusiness = false;
        },
        /**
         * 数据看板
         * type_value  2 为冷暖风水  1  采暖   3  其他
         * region_value  大区信息
         * province_code  省code
         * city_code  市code
         * business_uuid  代理商id
         * */
        getBoardData() {
            this.$store.commit("loadSwitch", true);
            console.log(this.dateTime);
            let data = {
                type_value: this.type_value,
                region_value: this.regionId,
                province_code: this.provinceCode,
                city_code: this.cityCode,
                business_uuid: this.businessId,
                start_date: this.dateTime[0].replace(/\//g, '-'),
                end_data: this.dateTime[1].replace(/\//g, '-'),
            }
            oWarmJs.getIndexBoard(data).then(res => {
                this.arrBoard = res.data.data.result.board || [];
                this.arrMapdata = res.data.data.result.mapdata || [];
                if (this.arrMapdata.length) {
                    let arrMap = [];
                    this.arrMapdata[this.nDisIndex].map.forEach(it => {
                        arrMap.push({
                            name: it.name,
                            value: it.num
                        })
                    })
                    this.arrMap = arrMap;
                    this.maxNum = this.arrMapdata[this.nDisIndex].max_num;
                }
                this.sTipsText = res.data.data.result.today || '';
                // this.drawregionCharts();// // 中国地图
                this.getIndexUserData();
            })
        },
        blurSeach() {
            this.nPage = 0;
            this.bEmptyLoad = false;
            this.arrUserLog = [];
            this.getIndexUserData();
        },
        /**
         * 首页-用户日志
         * type_value  2 为冷暖风水  1  采暖   3  其他
         * region_value  大区信息
         * province_code  省code
         * city_code  市code
         * business_uuid  代理商id
         * keyword  搜索客户
         * */
        getIndexUserData() {
            let data = {
                type_value: this.type_value,
                region_value: this.regionId,
                province_code: this.provinceCode,
                city_code: this.cityCode,
                business_uuid: this.businessId,
                start_date: this.dateTime[0].replace(/\//g, '-'),
                end_data: this.dateTime[1].replace(/\//g, '-'),
                keyword: this.seachKeyWord,
                page: this.nPage,
                limit: 20,
                selected: JSON.stringify(this.arrSelected)
            }
            // console.log(data);debugger
            this.$store.commit("loadSwitch", true);
            oWarmJs.getIndexUserLog(data).then(res => {
                let arrUserLog = this.groupBy(res.data.data.result, 'tag_date');
                this.arrUserLog = this.arrUserLog.concat(arrUserLog);
                this.$store.commit("loadSwitch", false);
                // 加载状态结束
                this.loading = false;
                if (res.data.data.result.length < 20) {
                    this.bEmptyLoad = true;
                    this.finished = true;
                }
            })
        },
        /**
         * 触底加载
         * */
        getSorll(event) {
            // let scrollBottom =
            //     event.target.scrollHeight -
            //     event.target.scrollTop -
            //     event.target.clientHeight;
            // if (scrollBottom <= 0 && !this.bEmptyLoad) { // 判断滚动到底部时
            //  操作
            this.nPage = this.nPage + 1;
            this.getIndexUserData();
            // }
        },
        /**
         * 数组分类
         * */
        groupBy(objectArray, property) {
            let obj = {};
            let result = [];
            objectArray.map((item) => {
                let key = item[property];
                if (item.field_tips) {
                    item.bTips = true;
                } else {
                    item.bTips = false;
                }
                item.tab_1.forEach((it, index) => {
                    if (item.field_tips && (it.field_name == '项目名称' || it.field_name == '合同名称')) {
                        it.field_value = it.field_value + `<span style='color:red;'>（${item.field_tips}）</span>`
                    }
                })
                //如果有这个key，就push一个对象
                if (obj[key]) {
                    obj[key].push(item);
                    //如果没有这个key，就把对象设置成数组格式（方便后面push进去）
                } else {
                    obj[key] = [item];
                }
            });
            //根据obj中有几个对象，挨个push进去，组成最后的数组
            for (const key in obj) {
                const element = obj[key];
                result.push({
                    tab_date: key,
                    arrElement: element,
                });

            }
            return result;
        },
        /**
         * 搜索
         * */
        chilkFrom(e) {
            this.arrSelected = e;
            this.bEmptyLoad = false;
            this.nPage = 0;
            this.arrUserLog = [];
            this.getIndexUserData(e);
        },
        // 点击全国省
        clickCity(id) {
            if (id == 1) {
                this.nCityIndex = id;
                let arrMap = [];
                this.arrMapdata[this.nDisIndex].map.forEach(it => {
                    arrMap.push({
                        name: it.name,
                        value: it.num
                    })
                })
                this.arrMap = arrMap;
                this.mapType = 'china';
                this.drawregionCharts();
            }
        },
        /**
         * 中国地图
         * */
        drawregionCharts() {
            let _that = this;
            if (_that.mapChart != null &&
                _that.mapChart != "" &&
                _that.mapChart != undefined) {
                _that.mapChart.dispose();
            }
            _that.mapChart = _that.$echarts.init(
                document.getElementById("china_map")
            );
            let maxNum = _that.maxNum;
            let arrColor = [];
            for (let i = 0; i < 5; i++) {
                let index = i;
                arrColor.unshift({
                    gt: index == 0 ? 0 : Number((index * (maxNum / 5)).toFixed(0)) + 1,
                    lte: Number(((index + 1) * (maxNum / 5)).toFixed(0)),
                    label: (index * (maxNum / 5)).toFixed(0) + '~' + ((index + 1) * (maxNum / 5)).toFixed(0),
                    color: colorType(i),
                })
            }

            function colorType(type) {
                switch (type) {
                    case 0:
                        return '#d1ddfb'
                        break;
                    case 1:
                        return '#a4b9f9'
                        break;
                    case 2:
                        return '#7797f6'
                        break;
                    case 3:
                        return '#4b74f4'
                        break;
                    case 4:
                        return '#2552f3'
                        break;
                }
            }

            let option = {
                tooltip: {
                    trigger: "item",
                    backgroundColor: 'rgba(0,0,0,0)',
                    extraCssText: 'padding:0;margin-top:-10px;margin-left:-10px;',
                    formatter: function (params) {
                        let value = isNaN(params.value) ? 0 : params.value;
                        if (value) {
                            let img = require('@/assets/images/hvac/dossier/label.png');
                            return `<div style='width:40px;height:40px;border-radius: 50%;overflow: hidden;
                                        box-shadow: 0px 0px 10px -2px #b7b5b5;
                                        display: flex;
                                        background:#ffffff;
                                        align-items: center;
                                        justify-content: center;'>
                                        <div style='width:32px;height:32px;border-radius: 50%;overflow: hidden;
                                        display: flex;
                                        align-items: center;
                                        background:#FF955A;
                                        justify-content: center;'>${value}</div>
                                        </div>`
                        }
                    },
                },
                visualMap: {
                    show: false,
                    left: 26,
                    bottom: 40,
                    showLabel: true,
                    min: 0,
                    max: 10000,
                    pieces: arrColor,
                },
                geo: {
                    map: this.mapType,
                    scaleLimit: {
                        min: 1,
                        max: 2,
                    },
                    zoom: 1.2,
                    top: 50,
                    label: {
                        normal: {
                            show: true,
                            fontSize: "10",
                            color: "#fff",
                        },
                        emphasis: {
                            color: '#fff',
                        }
                    },
                    itemStyle: {
                        normal: {
                            shadowBlur: 10,
                            shadowColor: "rgba(0, 0, 0, 0.2)",
                            borderColor: "#fff",
                        },
                        emphasis: {
                            areaColor: "#608df8",
                            shadowOffsetX: 0,
                            shadowOffsetY: 0,
                            borderWidth: 0,
                        },
                    },
                },
                series: [{
                    name: "",
                    type: "map",
                    mapType: _that.mapType,
                    geoIndex: 0,
                    data: this.arrMap,
                },],
            };

            _that.$nextTick(() => {
                _that.mapChart.resize();
            });
            _that.mapChart.setOption(option);
            _that.mapChart.on('click', function (param) {
                let objProvince = _that.arrMapdata[_that.nDisIndex].map.find(it => {
                    _that.clickMapType == it.type;
                    return it.name == param.name;
                })
                if (objProvince?.sublist.length) {
                    if (_that.clickMapType == 'province') {
                        let arrMap = [];
                        objProvince?.sublist.forEach(it => {
                            arrMap.push({
                                name: it.name,
                                value: it.num
                            })
                        })
                        _that.mapType = provinceGeo[param.name];
                        _that.arrMap = arrMap;
                        _that.$http.get('https://pro-core.babycdn.com/2021/aosmith/vuetest/map/province/' + provinceGeo[param.name] + '.json').then((obj) => {
                            _that.$echarts.registerMap(provinceGeo[param.name], obj.data);
                            _that.nCityIndex = 2;
                            _that.drawregionCharts()
                        })
                    }
                }
            })
        },
    },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.bottom_tab {
    padding-top: 12px;
    padding-bottom: env(safe-area-inset-bottom);
    display: flex;
    background-color: #ffffff;
    color: rgba(0, 0, 0, 0.2);
    position: fixed;
    width: 100%;
    z-index: 9;

    .bottom_item {
        width: 50%;
        height: 100px;

        img {
            margin: 0 auto;
            display: block;
            width: 52px;
            height: 52px;
        }

        .act {
            color: #000;
        }

        div {
            font-size: 26px;
            text-align: center;
        }
    }
}

.power {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: 999;
}

.user_city_nav {
    width: 50%;
    display: flex;
    margin: 28px auto;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid $deepGreen;

    div {
        width: 33.33%;
        font-size: 28px;
        padding: 10px 0;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;

        &:nth-child(2) {
            border-left: 1px solid $deepGreen;
            border-right: 1px solid $deepGreen;
        }
    }

    .active_city_item {
        background: $deepGreen;
        color: #fff;
    }
}

.user_map {
    width: 100%;
    height: 648px;
    margin-top: 21px;
    background: url("~@/assets/images/hvac/dossier/map_bg.png") no-repeat
        center/100% 100%;

    #china_map {
        width: 100%;
        height: 648px;
    }
}

::v-deep .van-notice-bar {
    border-radius: 16px;
    margin-top: 32px;
}

.app_content {
    width: 100%;
    margin-top: 32px;
    height: 100%;
    overflow-y: scroll;

    .bulletin_content {
        width: 100%;
        background: #ffffff;
        border-radius: 16px;
        margin-top: 32px;
        padding: 32px;
        box-sizing: border-box;

        .bulletin_warp {
            width: 100%;
            margin-top: 18px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .bulletin_warp_item {
                width: 202px;
                height: 128px;
                margin-top: 16px;
                background: #fafafa;
                border-radius: 16px;
                display: flex;
                flex-direction: column;
                padding-left: 24px;
                box-sizing: border-box;
                justify-content: center;

                div {
                    font-weight: 400;
                    font-size: 24px;
                    line-height: 34px;
                    color: #8b8b8b;
                }

                .num {
                    margin-top: 4px;
                    font-weight: 700;
                    font-size: 40px;
                    line-height: 48px;
                    color: #081374;
                }
            }
        }

        .bulletin_title {
            font-style: normal;
            font-weight: 500;
            font-size: 32px;
            line-height: 44px;
            color: #333333;
            display: flex;
            align-items: center;
        }

        .bulletin_icon::before {
            content: "";
            display: flex;
            align-items: center;
            width: 70px;
            height: 70px;
            background: url("~@/assets/images/hvac/dossier/bulletin_icon.png")
                no-repeat center/100% 100%;
        }

        .distribution_nav {
            width: 100%;
            border-radius: 10px;
            display: flex;
            align-items: center;
            height: 64px;
            overflow: hidden;

            .atv_nav {
                background: #0d53fc;
                color: #fff;
            }

            div {
                flex: 1;
                height: 64px;
                line-height: 64px;
                font-size: 24px;
                color: #a1a1a1;
                text-align: center;
            }
        }

        .distribution_icon::before {
            content: "";
            display: flex;
            align-items: center;
            width: 70px;
            height: 70px;
            background: url("~@/assets/images/hvac/dossier/map.png") no-repeat
                center/100% 100%;
        }

        .seach_warp {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;

            .seach_input {
                width: 542px;
                height: 80px;
                background: #f9f9fb;
                border: 2px solid #eeeeee;
                border-radius: 16px;
                display: flex;
                align-items: center;
                padding: 0 24px;
                box-sizing: border-box;

                &:before {
                    content: "";
                    display: block;
                    width: 50px;
                    height: 50px;
                    background: url("~@/assets/images/hvac/dossier/seach_icon.png")
                        no-repeat center/100% 100%;
                }

                input {
                    padding-left: 20px;
                    box-sizing: border-box;
                    height: 100%;
                    flex: 1;
                    background: #f9f9fb;
                }
            }

            .screen {
                width: 80px;
                height: 80px;
                background: #f9f9fb;
                border: 2px solid #eeeeee;
                border-radius: 16px;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .listError {
            width: 100%;
            text-align: center;
            font-size: 30px;
            padding: 100px 0;
            box-sizing: border-box;
        }

        .seach_list {
            width: 100%;

            .seach_item {
                width: 100%;
                margin-top: 32px;

                .seach_dateTime {
                    font-weight: 400;
                    font-size: 28px;
                    line-height: 40px;
                    color: #b0b0b0;
                    text-align: center;
                    margin-bottom: 24px;
                }

                .seach_item_warp {
                    width: 100%;
                    /*height: 358px;*/
                    background: #f9f9fb;
                    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.05);
                    border-radius: 16px;
                    overflow: hidden;
                    margin-bottom: 32px;

                    .green1 {
                        width: 100%;
                        height: 16px;
                        background: #bceed7;
                    }

                    .orange1 {
                        width: 100%;
                        height: 16px;
                        background: #ec975f4b;
                    }

                    .blue1 {
                        background: #4baed74b;
                    }

                    .grey1 {
                        background: #9393934b;
                    }

                    .red1 {
                        background: #e7595c4b;
                    }

                    .item_warp_content {
                        padding: 0 32px 0;
                        box-sizing: border-box;

                        .borderTop {
                            border-top: 1px solid #cacaca;
                        }

                        .uninfo_warp {
                            padding-top: 32px;
                            box-sizing: border-box;
                            margin-bottom: 32px;
                            width: 100%;

                            .uninfo_item {
                                margin-bottom: 16px;
                                display: flex;
                                align-items: center;
                                font-weight: 400;
                                font-size: 24px;
                                line-height: 34px;

                                .uninfo_item_left {
                                    width: 168px;
                                    color: #3d3c4f69;
                                }

                                .ellipsis {
                                    line-height: 34px;
                                    display: -webkit-box; //谷歌
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 2; //显示几行
                                    overflow: hidden;
                                    word-wrap: break-word;
                                    word-break: break-all;
                                }

                                .uninfo_item_right {
                                    width: 400px;
                                    //display: flex;
                                    //align-items: center;
                                    //text-align: justify;
                                    //flex-wrap: wrap;
                                    //justify-content: space-between;
                                }

                                .dian {
                                    div {
                                        font-size: 40px;
                                    }
                                }
                            }
                        }

                        .problem {
                            margin-bottom: 32px;
                            width: 100%;
                            height: 48px;
                            background: #f1e3e3;
                            border-radius: 16px;
                            font-weight: 500;
                            font-size: 24px;
                            line-height: 34px;
                            text-align: center;
                            color: #e95859;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }

                        .uninfo {
                            width: 100%;
                            height: 82px;
                            border-bottom: 1px solid #dddddd;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;

                            .item_green {
                                min-width: 140px;
                                height: 40px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-weight: 400;
                                font-size: 24px;
                                color: #fff;
                                border-radius: 20px;
                            }

                            .green {
                                background: #24ae71;
                            }

                            .orange {
                                background: #ec975f;
                            }

                            .blue {
                                background: #4baed7;
                            }

                            .grey {
                                background: #939393;
                            }

                            .red {
                                background: #e7595c;
                            }

                            .uninfo_name {
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                padding-left: 30px;
                                box-sizing: border-box;
                                flex: 1;

                                .manandday {
                                    color: red;
                                    font-size: 24px;
                                }

                                .name {
                                    width: 140px;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    font-weight: 700;
                                    font-size: 32px;
                                    line-height: 44px;
                                    color: #202b22;
                                }

                                .phone {
                                    font-weight: 400;
                                    font-size: 24px;
                                    line-height: 34px;
                                    margin-left: 5px;
                                    color: #202b22;
                                }
                            }
                        }
                    }
                }
            }
        }

        .journal_icon::before {
            content: "";
            display: flex;
            align-items: center;
            width: 70px;
            height: 70px;
            background: url("~@/assets/images/hvac/dossier/rizi.png") no-repeat
                center/100% 100%;
        }
    }

    .seach_warp {
        width: 100%;

        .seach_item_bottom {
            display: flex;
            justify-content: space-between;
            margin-top: 16px;
        }

        .seach_item_top {
            display: flex;
            justify-content: space-between;

            .right {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 14px 0 14px;
                box-sizing: border-box;
                font-size: 28px;
                color: #fff;
                font-weight: 400;

                .right_item {
                    flex: 1;
                    padding-left: 20px;
                    box-sizing: border-box;
                }
            }

            .right::after {
                content: "";
                display: flex;
                align-items: center;
                width: 50px;
                height: 50px;
                background: url("~@/assets/images/hvac/dossier/bottom_icon.png")
                    no-repeat center/100% 100%;
            }

            .right::before {
                content: "";
                display: flex;
                align-items: center;
                width: 50px;
                height: 50px;
                background: url("~@/assets/images/hvac/dossier/date_time.png")
                    no-repeat center/100% 100%;
            }
        }

        .seach_item_bottom {
            display: flex;
            justify-content: space-between;

            .right {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 14px 0 14px;
                box-sizing: border-box;
                font-size: 28px;
                color: #fff;
                font-weight: 400;

                .right_item {
                    flex: 1;
                    padding-left: 20px;
                    box-sizing: border-box;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }

            .right::after {
                content: "";
                display: flex;
                align-items: center;
                width: 50px;
                height: 50px;
                background: url("~@/assets/images/hvac/dossier/bottom_icon.png")
                    no-repeat center/100% 100%;
            }

            .right::before {
                content: "";
                display: flex;
                align-items: center;
                width: 50px;
                height: 50px;
                background: url("~@/assets/images/hvac/dossier/daili.png")
                    no-repeat center/100% 100%;
            }
        }

        .right {
            width: 65%;
            height: 80px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 16px;
        }

        .left {
            width: 33%;
            height: 80px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 14px 0 24px;
            box-sizing: border-box;
            font-weight: 400;
            font-size: 28px;
            line-height: 40px;
            color: #ffffff;

            span {
                display: inline-block;
                width: calc(100% - 50px);
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            &::after {
                content: "";
                display: flex;
                align-items: center;
                width: 50px;
                height: 50px;
                background: url("~@/assets/images/hvac/dossier/bottom_icon.png")
                    no-repeat center/100% 100%;
            }
        }
    }
}

.content {
    background: #f2f2f2;

    .assios_conent {
        height: calc(100vh - 100px - env(safe-area-inset-bottom));
        padding: 32px 24px 24px;
        box-sizing: border-box;
        position: relative;
    }
    .userinfo-wrap {
        position: relative;
        z-index: 1;
        height: 122px;
        display: flex;
        align-items: center;
        .user-left {
            flex: 1;
            display: flex;
            align-items: center;
            .head-img {
                width: 122px;
                height: 122px;
                background: #a88aa8;
                border-radius: 50%;
                margin-right: 16px;
                overflow: hidden;
                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                }
            }
            .hed-info {
                .name {
                    font-size: 32px;
                    font-weight: 400;
                    color: #ffffff;
                    span {
                        margin-left: 10px;
                        font-size: 26px;
                        color: rgba(255, 255, 255, 0.6);
                    }
                }
                .company {
                    margin-top: 5px;
                    font-size: 30px;
                    color: #ffffff;
                }
            }
        }
        .red-right {
            width: 76px;
            height: 76px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
                width: 46px;
                height: 50px;
            }
        }
    }
    .plane-title {
        display: flex;
        align-items: center;
        position: relative;
        height: 48px;
        z-index: 1;
        margin-top: 36px;
        img {
            width: 50px;
            height: 48px;
        }
        span {
            font-size: 32px;
            color: #ffffff;
            line-height: 38px;
        }
    }
    .info-box {
        position: relative;
        z-index: 1;
        display: flex;
        height: 92px;
        margin: 52px 0 48px 0;
        .info-item {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;
            &:last-child {
                &:after {
                    display: none;
                }
            }
            &:after {
                content: "";
                width: 1px;
                height: 40px;
                background: rgba(255, 255, 255, 0.5);
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);
            }
            .value {
                font-size: 48px;
                color: #fff;
            }
            .name {
                font-size: 24px;
                color: rgba(255, 255, 255, 0.6);
                margin-top: 5px;
            }
        }
    }
}

.bg_color {
    position: absolute;
    z-index: 0;
    //height: 440px;
    height: 840px;
    width: 100%;
    top: 0;
    left: 0;
    background: linear-gradient(180deg, #5868f8 -4.58%, #192597 110.63%);
}

.content_wrap {
    width: 100%;
    height: calc(100vh - 678px - env(safe-area-inset-bottom));
    position: relative;
    z-index: 1;
}

.nav_content {
    width: 640px;
    height: 80px;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    position: relative;
    z-index: 1;
}

.nav {
    width: 180px;
    height: 72px;
    border-radius: 36px;
    font-weight: 500;
    font-size: 30px;
    line-height: 72px;
    /* identical to box height */
    text-align: center;
    letter-spacing: 2px;
    color: rgba(255, 255, 255, 0.7);
}

.atv_nav {
    background: #222d93;
    color: #fff;
}

// 时间选择项样式
.time-item-wrap {
    padding: 6%;
    box-sizing: border-box;

    .time-item-title {
        display: flex;
        align-items: center;
        margin-bottom: 32px;

        div:first-child {
            width: 4px;
            height: 26px;
            background: #0d53fc;
        }

        div:last-child {
            font-size: 28px;
            font-weight: 400;
            margin-left: 12px;
            font-family: Abel-Regular, Abel;
            color: #333333;
            line-height: 33px;
        }
    }

    .time-item-content {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .time-item-content-item {
            padding: 18px;
            border: 1px solid #ddd;
            border-radius: 16px;

            font-size: 24px;
            color: #666666;
            line-height: 28px;
        }

        .time-item-content-item-act {
            padding: 20px;
            color: #0d53fc;
            border: none;
            background: rgba(13, 83, 252, 0.1);
        }
    }

    .time-input-wrap {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #666666;
        font-size: 24px;

        .time-input-item {
            width: 40%;
            padding: 18px;
            border: 1px solid #ddd;
            border-radius: 16px;
            font-size: 24px;
            color: #666666;
            line-height: 28px;
            text-align: center;
        }

        .time-input-item-act {
            padding: 20px;
            color: #0d53fc;
            border: none;
            background: rgba(13, 83, 252, 0.1);
        }
    }
}

// 搜索按钮样式
.search-btn {
    width: 100%;
    height: 180px;
    background: #ffffff;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 99999;
    box-shadow: 0px -10px 16px rgba(230, 240, 255, 1);
    display: flex;
    justify-content: center;
    align-items: center;

    .btn {
        width: 434px;
        height: 72px;
        background: #0d53fc;
        border-radius: 16px 16px 16px 16px;

        font-size: 24px;
        font-family: Abel-Regular, Abel;
        font-weight: 400;
        color: #ffffff;
        line-height: 72px;
        text-align: center;
    }
}

.timepicker-wrap {
    ::v-deep .van-picker__cancel {
        color: #333333;
        font-size: 32px;
    }

    ::v-deep .van-picker__confirm {
        color: #0d53fc;
        font-size: 32px;
    }

    ::v-deep .van-picker__title {
        color: #333333;
        font-size: 32px;
    }
}
</style>
